import DashboardSidebar from './DashboardSidebar';

export default DashboardSidebar;
